import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import TestResultItem from '@/components/TestResultItem.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import CustomProgressBar from '@/components/common/CustomProgressBar.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import CourseApi from '@/services/api/CourseApi'
  import { CourseModule } from '@/store/modules/course'
  import useSegment from '@/composables/useSegment'
  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import { useRoute } from 'vue-router/composables'
  import useI18n from '@/composables/useI18n'
  import type { Question, QuizCompletion } from '@/services/interfaces/QuizQuestion'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'QuizResults',
  props: {
    lessonCTA: {
      type: String,
      default: '',
    },
  },
  emits: ['next-lesson-or-module'],
  setup(__props, { emit }) {

  
  
  const route = useRoute()
  const { trackPage, pageViewed } = useSegment()
  const { currentCourseId, moduleId, lessonId, currentLesson } = useCourse()
  const { checkboxCircleGreen, wrongAnswerIcon, arrowRight } = useIcons()
  const { translateString } = useI18n()
  const quizCompletion = ref({} as QuizCompletion)
  const correctAnsCount = ref(0)
  const correctAnswerState = ref([] as boolean[])

  const isLoading = computed(() => {
    return !completionQuestions.value.length || !currentLesson.value
  })

  const completionId = computed((): string | (string | null)[] => {
    return route.query.completionId
  })

  const completionQuestions = computed((): Question[] => quizCompletion.value.questions ?? [])

  const passedQuiz = computed(() => quizCompletion.value.passed)

  const quizPercentage = computed((): number => {
    return Math.floor((correctAnsCount.value / completionQuestions.value.length) * 100) || 0
  })

  const toActivateCertificateText = computed(() => {
    return translateString('courses.toActivateCertificate')
  })

  const lessonQuizStatus = computed(() => {
    return passedQuiz.value ? translateString('passedQuiz') : translateString('failedQuiz')
  })

  const userTries = computed(() => currentLesson.value?.quiz?.meta.tries)

  const averageUserTries = computed(() => currentLesson.value?.quiz?.meta.usersAveragePassTries)

  const tryStatus = computed(() => translateString('quiz.quizResults.userTries', { tries: userTries.value }))

  const setActiveLessonAttributes = () => {
    CourseModule.getLesson({
      courseId: currentCourseId.value,
      moduleId: moduleId.value,
      lessonId: lessonId.value,
    })
  }

  const fetchQuizCompletion = () => {
    CourseApi.getLessonQuizCompletion(
      currentCourseId.value,
      moduleId.value,
      lessonId.value,
      completionId.value as string,
    ).then((completion) => {
      quizCompletion.value = completion
      completion.questions.forEach(() => correctAnswerState.value.push(false))
    })
  }

  const onCorrectAnswers = (isCorrect: boolean, index: number) => {
    if (isCorrect) {
      correctAnsCount.value++
      correctAnswerState.value.splice(index, 1, true)
    }
  }

  const nextLessonOrModule = () => {
    emit('next-lesson-or-module')
  }

  fetchQuizCompletion()
  setActiveLessonAttributes()

  onMounted(() => {
    trackPage('Course Lesson Quiz Results')
    pageViewed('Course Lesson Quiz Results')
  })

return { __sfc: true,emit, route, trackPage, pageViewed, currentCourseId, moduleId, lessonId, currentLesson, checkboxCircleGreen, wrongAnswerIcon, arrowRight, translateString, quizCompletion, correctAnsCount, correctAnswerState, isLoading, completionId, completionQuestions, passedQuiz, quizPercentage, toActivateCertificateText, lessonQuizStatus, userTries, averageUserTries, tryStatus, setActiveLessonAttributes, fetchQuizCompletion, onCorrectAnswers, nextLessonOrModule, computed, onMounted, ref, KetchUpButton, TestResultItem, LoadingSpinner, CustomProgressBar, SVGRenderer, CourseApi, CourseModule, useSegment, useCourse, useIcons, HTMLRenderer, useRoute, useI18n }
}

})